import { JetView } from 'webix-jet'; // Importing JetView class from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing a view for withdrawal requests.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Format date according to the application's date format configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        return {
            rows: [
                {
                    id: 'preloader', // Identifier for the preloader component
                    cols: [
                        {
                            view: 'datatable', // Define a datatable view
                            id: 'datatable', // Identifier for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                {
                                    id: 'Action', // Identifier for the Action column
                                    editor: 'combo', // Use a combo box for editing
                                    options: [
                                        // Options for the combo box
                                        { id: '', value: 'None' },
                                        { id: 'A', value: 'Approbave' },
                                        { id: 'R', value: 'Reject' },
                                        { id: 'P', value: 'Pay' },
                                    ],
                                    // Template for rendering the Action column
                                    template: "<span class='webix_icon fa-angle-down arrow'></span>#Action# ",
                                    header: 'Action', // Header text for the column
                                    width: 180, // Width of the column
                                },
                                {
                                    id: 'detailTittle', // Identifier for the detail title column
                                    header: '', // No header for this column
                                    width: 50, // Width of the column
                                    height: 25, // Height of the column
                                    tooltip: _('Detalles'), // Tooltip text for the column
                                    template: function (obj) {
                                        // Template for rendering the detail icon
                                        return "<span class='webix_icon wxi-close details'></span>";
                                    },
                                },
                                {
                                    id: 'Id', // Identifier for the Id column
                                    header: 'Id', // Header text for the column
                                    width: 100, // Width of the column
                                    sort: 'int', // Enable integer sorting
                                },
                                {
                                    id: 'ClientId', // Identifier for the ClientId column
                                    header: _('ID Cliente'), // Header text for the column, localized
                                    width: 100, // Width of the column
                                    sort: 'int', // Enable integer sorting
                                },
                                {
                                    id: 'Amount', // Identifier for the Amount column
                                    header: _('Valor'), // Header text for the column, localized
                                    width: 150, // Width of the column
                                    sort: 'int', // Enable integer sorting
                                },
                                {
                                    id: 'State', // Identifier for the State column
                                    header: _('Estado'), // Header text for the column, localized
                                    options: [
                                        // Options for the State column
                                        { id: '', value: _('None') },
                                        { id: 'A', value: _('Activado') },
                                        { id: 'C', value: _('Cancelado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                },
                                {
                                    id: 'CreatedLocal', // Identifier for the CreatedLocal column
                                    header: _('Fecha'), // Header text for the column, localized
                                    width: 150, // Width of the column
                                    sort: 'int', // Enable integer sorting
                                },
                            ],
                            onClick: {
                                // Event handler for click events
                                details: function (euv, id) {
                                    // Function to handle detail icon clicks
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('user:id', [
                                        // Trigger an event with the item Id
                                        item.Id,
                                    ]);
                                    // Show details based on screen size
                                    if (screen.width < 500 || screen.height < 500) {
                                        $$('filterDetails').show(); // Show filter details for small screens
                                    } else {
                                        $$('dColl').expand(); // Expand details for larger screens
                                    }
                                },
                            },
                            editable: true, // Enable editing of the datatable
                            tooltip: true, // Enable tooltips for the datatable
                            math: true, // Enable mathematical operations in the datatable
                            loadahead: 0, // Set load ahead parameter
                            datafetch: devConfig.getDefaultDataFetch(), // Fetch default data configuration
                            pager: 'pagerA', // Identifier for the pager component
                        },
                    ],
                },
            ],
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service from the app
        const _ = this.app.getService('locale')._;
        // Initialize the data table component
        grid = $$('datatable');
        // Get the current user ID from parameters
        const cur_user = this.getParam('user', true);
        // Construct the API URL for client withdrawal requests
        var url = devConfig.geturlApi() + 'es/Client/GetClientWithdrawalRequests?FromId=' + cur_user + '&';
        // Initialize filter string
        var filter = '';
        // Listen for the 'withdrawalAgent:filter' event to apply filters
        this.on(this.app, 'withdrawalAgent:filter', (filterData) => {
            // Convert filter data object to entries for iteration
            var object = Object.entries(filterData);
            var string1 = '';
            // Iterate through each filter entry
            for (var i = 0; i < object.length; i++) {
                // Check if the filter value is not an object and not empty
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle date range filter
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        // Handle single date filter
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            // Format date for filter
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    // Handle object type filter values
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        // Iterate through nested filter object
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                // Handle start date filter
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'MinCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    // Handle end date filter
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'MaxCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Append current user ID to filter string
            string1 = string1 + '&FromId=' + cur_user;
            // Clear existing data in the grid
            grid.clearAll();
            // Load data into the grid with the constructed URL and filter
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            // Update the filter variable
            filter = string1;
        });
        // Attach event for sorting the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Reload grid data with sorting parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir);
        });
        // Attach event before starting to edit a cell
        grid.attachEvent('onBeforeEditStart', function (id) {
            var item = this.getItem(id);
            console.log(item);
            // Check if the edited column is 'Action'
            if (id.column == 'Action') {
                var options = this.getColumnConfig('Action').collection;
                // Modify options based on the current state of the item
                if (item.State == 'A') {
                    options.remove('P');
                } else if (item.State == 'P') {
                    options.remove('A');
                } else {
                    return false; // Prevent editing if state is neither 'A' nor 'P'
                }
                console.log(id);
            }
        });
        // Attach event after editing a cell
        grid.attachEvent('onAfterEditStop', function (state, editor, ignoreUpdate) {
            console.log(state);
            var item = this.getItem(editor.row);
            console.log(item);
            // Check if the new value is different from the old value
            if (state.value != state.old) {
                // Handle approval of withdrawal requests
                if (state.value == 'A') {
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/AllowWithdrawalRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message(_('Error! '));
                            },
                            success: function (text, data, XmlHttpRequest) {
                                item.State = 'P'; // Update item state to 'P'
                                webix.message(_('Cell value was changed'));
                            },
                        });
                }
                // Handle payment of withdrawal requests
                if (state.value == 'P') {
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/PayWithdrawalRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message(_('Error! '));
                            },
                            success: function (text, data, XmlHttpRequest) {
                                item.State = 'I'; // Update item state to 'I'
                                webix.message(_('Cell value was changed'));
                            },
                        });
                }
                // Handle cancellation of client requests
                if (state.value == 'E') {
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/CancelClientRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message(_('Error! '));
                            },
                            success: function (text, data, XmlHttpRequest) {
                                item.State = 'E'; // Update item state to 'E'
                                webix.message(_('Cell value was changed'));
                            },
                        });
                }
            }
        });
        // Listen for the 'player:select' event to load data for the selected player
        this.on(this.app, 'player:select', (id) => {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + id);
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
